define('plugin/any-provider/AnyProviderPlugin',['require','lib/plugin/PluginAbstract','plugin/any-provider/model/AnyProviderModel','lib/view/BookingUrlBuilder','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AnyProviderModel = require('plugin/any-provider/model/AnyProviderModel');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var Config = require('Config');

    return PluginAbstract.extend({

        _model: null,
        _bookingModel: null,
        _providerStep: null,
        _anyProviderAllowed: true,
        _collection: null,
        _step: null,
        _unsupportedTimelines: ['classes'],

        /**
         * Initialize plugin
         */
        initStepManagerEvents: function () {
            this._model = new AnyProviderModel();
            this._bookingModel = this._stepManager.getBookingModel();

            this.fetchAnyProviderData();

            this.listenTo(this._bookingModel, 'change:service', this.updateAnyProviderIsAllowed);
            this.listenTo(this._stepManager, 'step:init:provider', this.addAnyProviderModel);
            this.listenTo(this._stepManager, 'step:show:provider', this.redirectNext);
        },

        /**
         * Update flag to show/hide any provider selection
         */
        updateAnyProviderIsAllowed: function () {
            this._anyProviderAllowed = true;
            var service = this._bookingModel.get('service');
            if (service) {
                _.each(service.unit_map, _.bind(function (customDuration) {
                    if (customDuration) {
                        this._anyProviderAllowed = false;
                    }
                }, this));
            }
        },

        initProviderStepVisibility: function () {
            if (this._model.isNew() || !this._model.get('hide_other_providers')) {
                return;
            }

            var hideStep = true;
            if (this._collection && this._collection.getDataCollection().length) {
                this._collection.getDataCollection().each(function (provider) {
                    _.each(provider.get('event_map'), function (customDuration) {
                        if (customDuration) {
                            hideStep = false;
                        }
                    }, this);
                }, this);
            }

            if (hideStep) {
                this._stepManager.hideStep('provider');
            }
        },

        /**
         * Subscribe to collection and model events to add model to collection when both is ready
         *
         * @param step
         * @param collection
         */
        addAnyProviderModel: function (step, collection) {
            this._collection = collection;
            this._step = step;

            this.listenTo(this._collection, 'sync', this.fetchAnyProviderData);
            this.listenTo(this._model, 'sync', this.addModelToCollection);

            this._collection.addFilter(_.bind(this.providerFilter, this));
        },

        /**
         * Show/hide any provider
         *
         * @param model
         * @return {boolean}
         */
        providerFilter: function (model) {
            // selected timeline is one, which does not support any unit plugin, so we just show all providers
            if (_.indexOf(this._unsupportedTimelines, Config.getInstance().getOption('timeline_type')) !== -1) {
                return true;
            }
            // given model is any-provider but it forbidden, so hide it
            if (model.get('id') === 'any' && !this._anyProviderAllowed) {
                return false;
            }
            // given model is not any-provider, so hide or show it depending on 'hide-other-providers' param
            if (model.get('id') !== 'any' && this._anyProviderAllowed) {
                return !this._model.get('hide_other_providers');
            }

            // hide any-unit option if service selected in booking model is part of class
            if (this._bookingModel.get('service')) {
                var service = this._bookingModel.get('service');
                if (model.get('id') === 'any' && service.class_id != undefined) {
                    return false;
                }
            }

            return true;
        },

        /**
         * Fetches any provider data from server
         */
        fetchAnyProviderData: function () {
            if (this._model.isNew()) {
                this._model.fetch();
            } else {
                this.addModelToCollection();
            }
        },

        /**
         * Adds any provider model to provider collection
         */
        addModelToCollection: function () {
            this.initProviderStepVisibility();

            this._collection.getDataCollection().add(this._model);
            this._collection.performFilters();

            this._step.updateInfo();
            this._step.done();

            this.redirectNext();
        },

        redirectNext: function () {
            if (this._model.isNew() || !this._anyProviderAllowed || !this._bookingModel.allowRedirectOnAnyProvider) {
                return;
            }
            // predefined provider takes over any_unit
            var predefined = Config.getInstance().getOption('predefined') || {};
            if (predefined.provider_id || predefined.provider) {
                return;
            }

            var providerId = this._model.get('id');
            var selectedProviderId = this._bookingModel.get('provider_id');
            var switchedTimeline = ['classes_plugin'];

            if(selectedProviderId && selectedProviderId !== providerId && _.indexOf(switchedTimeline, Config.getInstance().getOption('timeline_type')) === -1) {
                providerId = selectedProviderId;
            }
                
            if (this._model.get('hide_other_providers')) {
                var urlBuilder = BookingUrlBuilder.getInstance();
                Backbone.history.navigate(urlBuilder.buildUrl('booking_step', {
                    provider: providerId,
                }), {'trigger': true});
            }
        }

    });

});
